// Supermove
import {gql} from '@supermove/graphql';
import {Form} from '@supermove/hooks';
import {ProjectModel} from '@supermove/models';
import {withFragment} from '@supermove/utils';

export type ProjectReferralInformationFormFieldsType = {
  projectId: string;
  referralSource?: string;
  referralDetails?: string;
};

export type ProjectReferralInformationFormType = Form<{
  projectReferralInformationForm: ProjectReferralInformationFormFieldsType;
}>;

const edit = withFragment<ProjectModel, ProjectReferralInformationFormFieldsType>(
  (project) => ({
    projectId: project.id,
    referralSource: project.referralSource,
    referralDetails: project.referralDetails,
  }),
  gql`
    fragment ProjectReferralInformationForm_edit on Project {
      id
      referralSource
      referralDetails
    }
  `,
);

const toMutation = ({
  projectId,
  referralSource,
  referralDetails,
}: ProjectReferralInformationFormFieldsType): ProjectReferralInformationFormFieldsType => ({
  projectId,
  referralSource,
  referralDetails,
});

const ProjectReferralInformationForm = {
  edit,
  toMutation,
};

export default ProjectReferralInformationForm;
